"use client";

import type { QRProps } from "@/contexts/QREditorContext/types";
import { UseWebsiteDataResult, WebsiteTemplateTranslations } from "../types";
import { usePreviewData } from "@/features/previews/shared/hooks/usePreviewData";

/**
 * Resolves website preview data from props with QREditorContext fallback.
 * Handles data normalization and provides ready-to-consume data for website template.
 */
export const useWebsiteData = (props: QRProps<"website">): UseWebsiteDataResult => {
  const { data, isInitPreview: isInitialPreview } = usePreviewData(props);

  const translations = props.previewTranslations?.["website"] as WebsiteTemplateTranslations;

  return {
    translations,
    isInitialPreview,
    data,
  };
};
